export default __webpack_public_path__ + "static/media/gallery6.39a67826.jpg";